import type NonEmptyText from './non-empty-text';
import type { IPositionInit } from './position';
import { assertIsInstanceOfNonEmptyText } from './assertions';
import Position from './position';

interface ITextPosition extends ITextPositionInit {}

interface ITextPositionInit extends IPositionInit {
	readonly text: NonEmptyText;
}

export default class TextPosition extends Position implements ITextPosition {
	public get text(): NonEmptyText {
		return this.#text;
	}

	#text: NonEmptyText;

	public constructor({ description, index, litra, note, parent, price, quantity, text }: ITextPositionInit) {
		super({ description, index, litra, note, parent, price, quantity });
		assertIsInstanceOfNonEmptyText(text);
		this.#text = text;
	}
}
